export default class InvoiceNcfController {
  constructor($state, $uibModal,ContentService, isMobile) {
    this.modal = $uibModal;
    this.$state = $state;
    this.service = ContentService;
    this.isMobile = isMobile;
  }

  $onInit(){
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.subscriptions.push(
      this.ncfObservable.subscribe(ncfList => this.ncfList = ncfList)
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openNCFModal(ncfInvoice){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'new-ncf-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance) => {
        "ngInject";
        $scope.ncfInvoice = ncfInvoice || {};
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.registerNCF = () => {
          that.subscriptions.push(
            that.service.registerNCF($scope.ncfInvoice).subscribe(
              (addedNcf) => {
                that.ncfList.push(addedNcf);
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        }
        $scope.editNCF = () => {
          debugger;
          that.subscriptions.push(
            that.service.changeNCF($scope.ncfInvoice).subscribe(
              (resp) => {
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        }
      }
    })
  }

  deleteNCF(ncf){
    this.subscriptions.push(
      this.service.deleteNCF(ncf.id).subscribe(
        (resp) => {
          this.ncfList.splice(this.ncfList.indexOf(ncf), 1);
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }

}

 InvoiceNcfController.$inject = ['$state', '$uibModal', 'ContentService', 'isMobile'];


// WEBPACK FOOTER //
// ./src/app/pages/invoice-ncf/invoice-ncf.controller.js